import {Component} from '@angular/core';

@Component({
  selector: 'app-provider-dashboard',
  templateUrl: './provider-dashboard.component.html',
})
export class ProviderDashboardComponent {}
